export const TRIP_CATEGORY_LABEL = "Drop-off at the same location";
export const CONTINUE = "Continue";
